module.exports = __webpack_public_path__ + "img/felc-国际赛区.ab2603f0.png";